import React from 'react';
import {Redirect} from 'react-router-dom';

export const ActionPlanAppConfig = {
    settings: {
        layout: {}
    },
    routes  : [
        {
            path     : '/apps/action-plan/:id',
            component: React.lazy(() => import('./ActionPlanApp'))
        },
        {
            path     : '/apps/action-plan/:username?',
            component: () => <Redirect to="/apps/action-plan/all"/>
        }
    ]
};
